import * as React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import Seo from "../components/seo"

const HardwarePage = () => (
  <Layout>
  <div className="masthead-followup row m-0 bg-white border border-white text-center">
	 <div className="col-12 col-md-12 p-12 p-md-3 bg-white border border-white text-center"></div>
	  <div className="col-12 col-md-12 p-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
    <Seo title="HARDWARE MESIN KASIR ALAT KASIR BARCODE" />
    <h2><strong>HARDWARE KASIR</strong></h2>
    <p>
Perangkat dan peralatan kasir kompleks untuk menunjang usaha berasarkan type nya, mesin kasir hybrid tablet pos portable untuk kebutuhan transaksi dan pembukuan pada usaha kecil dan menengah, all in one touchscreen pos untuk kebutuhan bertransaksi dan pencatatan pembukuan terbaik , sensor alarm security untuk keamanan pada usaha .
	</p>
	  <img alt="mesin kasir online" width="100%" className="img-fluid shadow" src="https://res.cloudinary.com/hockeycorp/image/upload/v1579757792/Client_kvdnba.jpg"/>
	    <h3><strong>INTEGRATION SHARED</strong></h3>
    <p>
Shared databased untuk kebutuhan akses akan banyak mesin kasir dan pc office dalam berbagai kebutuhan untuk kebutuhan divisi semakin memudahkan dan mempercepat proses transaksi hingga pembukuan retail dengan divisi inventori stok - kasir penjualan - finance - backoffice admin, resto cafe dengan divisi : waiters - kitchen - kasir - admin backoffice mudah untuk diwujudkan,dan tentu penggunaan single standalone mesin kasir tunggal dalam kebutuhan transaksi mu.
</p>
</div>
	  <div className="col-12 col-md-8 p-0 p-md-0 shadow bg-light border border-white text-dark lead text-center">
	  <img alt="software kasir, program kasir,aplikasi kasir online" class="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1579983067/kasir%20hardware/mesin_kasir_murah_modern_mewah_znmhsf.jpg"/>
</div>
	  <div className="col-12 col-md-4 p-0 p-md-0"></div>
	 	  <div className="col-12 col-md-8 col-md-5 p-0 p-md-0"></div> 
	  <div className="col-12 col-md-4 p-3 p-md-5 shadow bg-light border border-white text-dark lead text-center">
 <h3><strong>HYBRID</strong></h3>
    <p>
Portable mesin kasir modern persmebahan dari hewllet packard tablet windows untuk usaha mu.
</p><Link to="/hybrid" className="button btn btn-outline-white">More info</Link>
</div>
	  <div className="col-12 col-md-8 p-0 p-md-0 shadow bg-light border border-white text-dark lead text-center">
	  <img alt="software kasir, program kasir,aplikasi kasir online" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1568369085/touchscreen_yonrpa.jpg"/>
</div>
	  <div className="col-12 col-md-4 p-0 p-md-0"></div>
	 	  <div className="col-12 col-md-8 col-md-5 p-0 p-md-0"></div> 
	  <div className="col-12 col-md-4 p-3 p-md-5 shadow bg-light border border-white text-dark lead text-center">
 <h3><strong>TOUCHSCREEN</strong></h3>
    <p>
All in one point of sale technology modern desain slim fashionable by ASUS technology.
</p><Link to="/touchscreenpos" className="button btn btn-outline-white">More info</Link>
</div>
	  <div className="col-12 col-md-8 p-0 p-md-0 shadow bg-light border border-white text-dark lead text-center">
	  <img alt="software kasir, program kasir,aplikasi kasir online" className="img-fluid" src="https://res.cloudinary.com/hockeycorp/image/upload/v1568371288/alarm_wwismc.jpg"/>
</div>
	  <div className="col-12 col-md-4 p-0 p-md-0"></div>
	 	  <div className="col-12 col-md-8 col-md-5 p-0 p-md-0"></div> 
	  <div class="col-12 col-md-4 p-3 p-md-5 shadow bg-light border border-white text-dark lead text-center">
 <h3><strong>SECURITY</strong></h3>
    <p>
Sensor alarm security terbaik untuk menjaga produk produk mu dari pencurian.
</p><Link to="/security" className="button btn btn-outline-white">More info</Link>
</div>
	  <div className="col-12 col-md-12 p-3 p-md-5 bg-white border border-white text-dark lead text-center">
    <p>
Pilih paket hardware kasir sesuai dengan kebutuhan mu.
</p>
</div>
	</div>
  </Layout>
)

export default HardwarePage